import ReactPlayer from 'react-player'

function AdCreative({
    creativeURL,
    creativeExt,
    width='100%',
    height,
    objectFit,
    shouldAutoPlay,
    hideControls,
    isMuted,
    borderRadius,
}) {
    function isExtSupportedVideo(ext) {
        return ['mp4'].includes(ext)
    }

    function isExtSupportedImage(ext) {
        return ['jpg', 'jpeg', 'png', 'webp'].includes(ext)
    }

    if (isExtSupportedImage(creativeExt)) {
        return (
            <img
                src={creativeURL}
                width={width}
                height={height}
                objectFit={objectFit}
                style={{
                    borderRadius: borderRadius,
                    objectFit: objectFit,
                }}
            />
        )
    }

    if (isExtSupportedVideo(creativeExt)) {
        return (
            <ReactPlayer
                url={creativeURL}
                controls={!hideControls}
                loop={true}
                muted={isMuted ?? true}
                onBufferEnd={() => {

                }}
                height='100%'
                width='100%'
                playing={shouldAutoPlay}
            />
        )
    }
}

export default AdCreative;